import classNames from "classnames";
import connectToStores from "alt-utils/lib/connectToStores";
import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import TextareaAutosize from "react-autosize-textarea";

import ChatActions from "../../actions/ChatActions";
import SvgIcon from "../common/SvgIcon";
import iconSprite from "../../../../images/img/chat/icons.svg";
import QuestionStore from "../../stores/chat/QuestionStore";
import ResponseStore from "../../stores/chat/ResponseStore";
import { isMobileDevice } from "../../utils/Utils";

/*
 * HEADS UP!
 *
 * This component implements its own shouldComponentUpdate. So if something it's
 * not working correctly or the component is not updating itself, make sure to
 * check that methdod.
 */

class TestimonialForm extends Component {
    constructor() {
        super();

        this.state = {
            testimonialText: "",
            testimonialTextIsFocused: false,
        };

        this.onBlur = this.onBlur.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancelKeyPress = this.onCancelKeyPress.bind(this);

        this.inputRef = createRef();
    }

    componentDidMount() {
        if (!isMobileDevice()) this.onFocus();
        this.props.setOffsetBottomOfMessageList();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const testimonialTextIsFocused = this.state.testimonialTextIsFocused !== nextState.testimonialTextIsFocused;
        const testimonialTextChanged = this.state.testimonialText !== nextState.testimonialText;

        return testimonialTextIsFocused || testimonialTextChanged;
    }

    onChange(event) {
        this.setState({ testimonialText: event.target.value });
    }

    onFocus() {
        if (this.inputRef.current) {
            this.setState(
                () => ({ testimonialTextIsFocused: true }),
                () => this.inputRef.current.focus()
            );
        }
    }

    onBlur() {
        this.setState({ testimonialTextIsFocused: false });
    }

    onKeyPress(event) {
        if (!isMobileDevice() && event.keyCode === 13 && !(event.altKey || event.ctrlKey || event.shiftKey)) {
            this.onSubmit(event);
        }
    }

    onSubmit(event) {
        const { response, question } = this.props;
        const { testimonialText } = this.state;

        if (testimonialText.trim().length) {
            ChatActions.responseAddTestimonial({
                expertId: response.recognitionRecipient.id,
                questionUuid: question.uuid,
                text: testimonialText.trim(),
            });
            this.setState({ testimonialText: "" });
        } else {
            this.onFocus();
        }
        event.preventDefault();
    }

    onCancel(event) {
        ChatActions.responseToggleTestimonialForm();
        event.preventDefault();
    }

    onCancelKeyPress(event) {
        if (event.charCode === 32 || event.charCode === 13) {
            this.onCancel(event);
        }
    }

    static getStores() {
        return [QuestionStore, ResponseStore];
    }

    static getPropsFromStores() {
        return {
            question: QuestionStore.getQuestion(),
            response: ResponseStore.getCurrentResponse(),
        };
    }

    render() {
        const { testimonialTextIsFocused, testimonialText } = this.state;
        const contentClass = classNames({
            content: true,
            "is-focused": testimonialTextIsFocused,
        });

        return (
            <form onSubmit={this.onSubmit} className="message-form-container testimonial-form">
                <div className={contentClass}>
                    <SvgIcon src={iconSprite} id="icon-pencil" className="icon-pencil" />
                    <TextareaAutosize
                        className="message-input"
                        id="testimonialForm"
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        onKeyDown={this.onKeyPress}
                        placeholder={i18n.t("rtm.text.write_a_testimonial_for_them")}
                        onResize={this.props.setOffsetBottomOfMessageList}
                        ref={this.inputRef}
                        rows={1}
                        value={testimonialText}
                    />
                    {testimonialText.trim().length ? (
                        <button className="btn submit-btn" type="submit">
                            <SvgIcon src={iconSprite} id="icon-airplane-envelope" />
                        </button>
                    ) : (
                        <a
                            className="cancel-testimonial-link"
                            onKeyPress={this.onCancelKeyPress}
                            onClick={this.onCancel}
                            tabIndex={0}
                        >
                            {i18n.t("rtm.button.cancel")}
                        </a>
                    )}
                </div>
            </form>
        );
    }
}

TestimonialForm.propTypes = {
    question: PropTypes.shape({}).isRequired,
    response: PropTypes.shape({}).isRequired,
    setOffsetBottomOfMessageList: PropTypes.func.isRequired,
};

export default connectToStores(TestimonialForm);
